import React, { useEffect, useState } from 'react';
import { clientLink } from '../../utils/links';
import { fetchAccessToken } from '../../utils/accessToken';

/**
 * The one link a client needs. Permanent per project, shared by everyone on
 * the client team, and copied from here into an email.
 *
 * Nothing is shown until the project's stored access token has been read, so a
 * staff member can never copy a link that is missing it.
 */
export function ClientLink({
  slug,
  projectId
}: {
  slug: string;
  projectId: string;
}) {
  const [copied, setCopied] = useState(false);
  /* The project's own access token, used solely to build this link. */
  const [token, setToken] = useState('');
  const [checked, setChecked] = useState(false);
  const link = clientLink(slug, token);
  useEffect(() => {
    let live = true;
    setToken('');
    setChecked(false);
    void fetchAccessToken(slug, projectId).then(value => {
      if (!live) return;
      setToken(value);
      setChecked(true);
    });
    return () => {
      live = false;
    };
  }, [slug, projectId]);
  async function copy() {
    if (!link) return;
    try {
      await navigator.clipboard.writeText(link);
    } catch {
      /* Clipboard unavailable — the link is on screen to copy by hand. */
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  }
  return <div className="mt-10 flex flex-wrap items-baseline gap-x-8 gap-y-4 border-t border-ruleDark pt-8" data-id="element-179" data-mp="7ra19d1x544w">
      <div data-id="element-180" data-mp="vhe8duebfm0n">
        <p className="label m-0 text-paper/40" data-id="element-181" data-mp="vguxuyqzvzwn">Client Link</p>
        <p className="mt-3 break-all font-sans text-sm tracking-wide2 text-paper/70" data-id="element-182" data-mp="10ffpi9s6lb9h">
          {link || (checked ? 'Secure link unavailable — the project’s access token could not be read.' : 'Preparing secure link…')}
        </p>
      </div>
      {link && <button type="button" onClick={copy} className="label border border-paper/30 px-5 py-3 text-paper/70 transition-colors duration-150 ease-out hover:border-paper hover:text-paper" data-id="element-183" data-mp="1eep10w5fzh74">
          {copied ? 'Copied ✓' : 'Copy Link'}
        </button>}
    </div>;
}